import React from 'react';
import { GameProviders, useGameStateContext } from './app/GameProviders';
import { AppShell } from './app/AppShell';
import { TitleMenu } from './components/TitleMenu';
import { LoadingScreen } from './components/LoadingScreen';
import { SplashScreen } from './components/SplashScreen'; // Import SplashScreen

function AppContent() {
  const { gameState, setGameState } = useGameStateContext();
  
  if (gameState === 'splash') { // New splash state
    return <SplashScreen onLoadingComplete={() => setGameState('title')} />;
  }

  if (gameState === 'title') {
    return <TitleMenu />;
  }
  
  if (gameState === 'loading') {
    return <LoadingScreen onLoadingComplete={() => setGameState('playing')} />;
  }
  
  return <AppShell />;
}

function App() {
  return (
    <GameProviders>
      <AppContent />
    </GameProviders>
  );
}

export default App;
